import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"height":"7rem"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" > ")

import { computed } from 'vue';
import { v4 as uuidv4 } from 'uuid';


export default /*#__PURE__*/_defineComponent({
  props: {
  data: {
    type: Array as () => Array<any>,
    default: [],
  },
},
  setup(__props) {

const props = __props



const extendedData = computed(() =>
  props.data
    .map((it) =>
      [{ name: it.name, type: 'head', id: uuidv4() }].concat(
        it.reverseEventList || []
      )
    )
    .reduce((prev, cur: any) => prev.concat(...cur), [])
);

const tableRowClassName = ({ row }: { row: any; rowIndex: number }) => {
  if (row.type === 'head') {
    return 'table-head';
  } else {
    return 'table-body';
  }
};

return (_ctx: any,_cache: any) => {
  const _component_simple_table_column = _resolveComponent("simple-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_table, {
      class: "fotile-table",
      data: _unref(extendedData),
      "row-key": "id",
      height: "100%",
      style: {"background-color":"transparent","--border-color":"transparent"},
      "row-class-name": tableRowClassName
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_simple_table_column, {
          label: "事件名称",
          prop: "name",
          "show-overflow-tooltip": ""
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}
}

})